import React from 'react';
import './LegalPages.css';

const PrivacyPolicy = ({ onClose }) => {
  return (
    <div className="legal-overlay">
      <div className="legal-modal">
        <div className="legal-header">
          <h1>Privacy Policy</h1>
          <button className="legal-close" onClick={onClose} aria-label="Close">×</button>
        </div>
        
        <div className="legal-content">
          <p className="legal-updated">Last updated: {new Date().toLocaleDateString()}</p>
          
          <section>
            <h2>Information We Collect</h2>
            <p>When you use Immuta Hash Gallery, we may collect:</p>
            <ul>
              <li><strong>Wallet Information:</strong> Your connected Hedera wallet address and associated NFT data</li>
              <li><strong>Gallery Data:</strong> Your created galleries, uploaded assets, and gallery configurations</li>
              <li><strong>Usage Analytics:</strong> Anonymous usage statistics to improve our service</li>
              <li><strong>Device Information:</strong> Browser type, device type, and performance metrics</li>
            </ul>
          </section>

          <section>
            <h2>How We Use Your Information</h2>
            <p>We use collected information to:</p>
            <ul>
              <li>Provide and maintain the gallery service</li>
              <li>Display your NFTs and manage your galleries</li>
              <li>Improve our platform and user experience</li>
              <li>Communicate with you about service updates</li>
              <li>Ensure platform security and prevent abuse</li>
            </ul>
          </section>

          <section>
            <h2>Information Sharing</h2>
            <p>We do not sell, trade, or rent your personal information. We may share information only:</p>
            <ul>
              <li>With your explicit consent</li>
              <li>To comply with legal obligations</li>
              <li>To protect our rights and prevent fraud</li>
              <li>With service providers who assist in operations (under strict confidentiality)</li>
            </ul>
          </section>

          <section>
            <h2>Data Storage and Security</h2>
            <p>Your data is stored securely using industry-standard encryption. Gallery data is stored on our servers, while your wallet remains under your control. We implement appropriate security measures to protect against unauthorized access.</p>
          </section>

          <section>
            <h2>Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access and review your stored data</li>
              <li>Request deletion of your galleries and associated data</li>
              <li>Disconnect your wallet at any time</li>
              <li>Opt out of analytics collection</li>
            </ul>
          </section>

          <section>
            <h2>Cookies and Tracking</h2>
            <p>We use minimal cookies and local storage to:</p>
            <ul>
              <li>Maintain your session and preferences</li>
              <li>Remember your gallery settings</li>
              <li>Provide analytics (anonymized)</li>
            </ul>
            <p>You can disable cookies in your browser settings, though this may affect functionality.</p>
          </section>

          <section>
            <h2>Third-Party Services</h2>
            <p>Our platform integrates with:</p>
            <ul>
              <li><strong>Hedera Network:</strong> For blockchain data and NFT information</li>
              <li><strong>Wallet Providers:</strong> HashPack, Blade, and other Hedera wallets</li>
              <li><strong>Analytics Services:</strong> For anonymous usage statistics</li>
            </ul>
            <p>These services have their own privacy policies which we encourage you to review.</p>
          </section>

          <section>
            <h2>Children's Privacy</h2>
            <p>Our service is not intended for children under 13. We do not knowingly collect personal information from children under 13. If you believe a child has provided us with personal information, please contact us.</p>
          </section>

          <section>
            <h2>Changes to Privacy Policy</h2>
            <p>We may update this Privacy Policy periodically. We will notify users of significant changes via email or platform notifications. Continued use constitutes acceptance of updated terms.</p>
          </section>

          <section>
            <h2>Contact Us</h2>
            <p>If you have questions about this Privacy Policy or your data, contact us via:</p>
            <p>Discord: <a href="https://discord.gg/wWrwKhJu54" target="_blank" rel="noopener noreferrer">https://discord.gg/wWrwKhJu54</a><br />
            Subject: Privacy Policy Inquiry</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;